import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios from 'axios';
import authService from './api-authorization/AuthorizeService';
import { toast } from 'react-toastify';
import Pricelist from './Pricelist';
import AddPriceListTier from './AdminPriceListsAddTierModal';

interface PriceListTierList {
    id: number;
    uniqueId: string;   //to cater for customer and tier pricelists
    name: string;
    typeId: number;
}

interface GenericList {
    id: number;
    name: string;
}

interface Item {
    id: number;
    name: string;
    defaultDays: number;
    typeId: number;
    overhireRequired: boolean;
}

interface PriceListItem {
    id: number;
    tierId: number;
    customerId: number;
    customerName: string;
    itemId: number;
    itemTypeId: number;
    hirePeriod: number;     //used for fencing custom
    frequencyId: number;
    locationId: number;
    metreId: number;
    baseDays: number;
    basePrice: number;
    baseMetres: number;
    useBtm: boolean;
    metreRate: number;
    travelAmount: number;
    baseAdditionalHireRate: number;
    additionalHireRate: number;
    extraHourRate: number;
    overhireRequired: boolean;
    statusId: number;
    isDirty: boolean;
}

interface TierDiscount {
    name: string;
    startDays: number;
    endDays: number;
    discountPercent: number;
}

const AdminPriceListEventData = (props: RouteComponentProps<{}>) => {
    const [pricelistTiers, setPricelistTiers] = React.useState<PriceListTierList[]>([]);
    const [itemList, setItemList] = React.useState<Item[]>([]);
    const [frequencyList, setFrequencyList] = React.useState<GenericList[]>([]);
    const [locationList, setLocationList] = React.useState<GenericList[]>([]);
    const [metresList, setMetresList] = React.useState<GenericList[]>([]);
    const [priceListItems, setPriceListItems] = React.useState<PriceListItem[]>([]);
    const [priceListTier, setPriceListTier] = React.useState({ priceListUniqueId: "", priceListTierId: -1, priceListTierType: -1 });
    const [systemCompanyId, setSystemCompanyId] = React.useState(3);
    const [loading, setLoading] = React.useState(false);
    const [pricelistLoading, setPricelistLoading] = React.useState(false);
    const [customerOptions, setCustomerOptions] = React.useState<GenericList[]>([]);
    const [showAddTier, setShowAddTier] = React.useState(false);
    const [tierName, setTierName] = React.useState("");
    const [tierCustomerId, setTierCustomerId] = React.useState(-1);
    const [useOverhireRate, setUseOverhireRate] = React.useState(true);
    const [readOnly, setReadOnly] = React.useState(false);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});


    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=AdminPricelistsView&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
            .then(res => {
                if (res.data == true) {
                    getPriceListData();
                } else if (res.data == false) {
                    //redirect to 403 permission denied
                    props.history.push("/accessdenied")
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    }


    const getPriceListData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/PriceList/GetPricelistData?SubId=' + user.sub + '&IsEws=false&IsPumpClean=false&IsEpa=false&IsFencing=false&IsEvent=true', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setItemList(res.data.itemList);
            setFrequencyList(res.data.frequencyList);
            setLocationList(res.data.locationList);
            setCustomerOptions(res.data.customerOptions);
            setPricelistTiers(res.data.priceListTier);
            setSystemCompanyId(res.data.systemCompanyId);
            setReadOnly(res.data.readOnly);
            setLoading(false);
        }).catch(error => {
            toast.error(error.message);
        });
    }

    const getPricelist = async (id: number, typeId: number) => {
        if (id > 0) {
            const token = await authService.getAccessToken();
            const user = await authService.getUser();
            axios.get('api/PriceList/GetPricelistEvent?SubId=' + user.sub + '&Id=' + id + '&PriceListType=' + typeId, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                var pricelist = res.data.priceList;
                let pricelistItem = addBlankRow(id, typeId * 1);
                pricelist.push(pricelistItem);
                setPriceListItems(pricelist);
                setPricelistLoading(false);
            })
            .catch(error => {
                toast.error(error.message);
            });
        } else {
            setPriceListItems([]);
            setPricelistLoading(false);
        }
    }

    const addBlankRow = (id: number, typeId: number) => {
        var tierId = -1;
        var customerId = -1;
        if (typeId === 1) {
            tierId = id;
        } else {
            customerId = id;
        }

        let pricelistItem: PriceListItem = {
            id: 0,
            tierId: tierId,
            customerId: customerId,
            customerName: "",
            itemId: -1,
            itemTypeId: 0,
            hirePeriod: 0,
            frequencyId: -1,
            locationId: -1,
            metreId: -1,
            baseDays: 1,
            basePrice: 0,
            baseMetres: 0,
            useBtm: false,
            metreRate: 0,
            travelAmount: 0,
            baseAdditionalHireRate: 0,
            additionalHireRate: 0,
            extraHourRate: 0,
            overhireRequired: false,
            statusId: 1,
            isDirty: false
        };

        return pricelistItem;
    }

    const handlePriceListChange = (e: any) => {
        var uniqueId = e.target.value;
        var plId = uniqueId.substring(1) * 1;
        let typeId = 1;

        if (uniqueId != "") {
            let priceListOption = pricelistTiers[e.target.selectedIndex - 1];
            if (priceListOption) {
                typeId = priceListOption.typeId;
            }
        }

        setPriceListTier({ priceListUniqueId: uniqueId, priceListTierId: plId, priceListTierType: typeId });

        if (uniqueId != "") {
            getPricelist(plId, typeId);
        }
    }

    //ADD TIER
    const addTier = () => {
        setTierName("");
        setTierCustomerId(-1);
        setShowAddTier(true);
    }

    const hideAddTier = () => {
        setTierName("");
        setTierCustomerId(-1);
        setShowAddTier(false);
    }

    const updateTierName = (tier: string) => {
        setTierName(tier);
    }

    const updateCustomer = (customerId: number) => {
        setTierCustomerId(customerId);
    }

    const updateTierDiscount = (tierDiscount: TierDiscount[]) => {
        //not used for Event Pricelists
    }

    const updateUseOverhireRate = async (useOverhireRate: boolean) => {
        const token = await authService.getAccessToken();

        var saveUseOverhire = {
            id: priceListTier.priceListTierId,
            typeId: priceListTier.priceListTierType,
            useOverhireRate: useOverhireRate
        };

        axios.post('api/PriceList/SaveTierUseOverhireRate', saveUseOverhire, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Use Overhire Rate Saved Successfully");
                setUseOverhireRate(useOverhireRate);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const saveAddTier = (typeId: number) => {
        saveAddNewTier(typeId);
    }

    const saveAddNewTier = async (typeId: number) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let plTiers = [...pricelistTiers];

        if (typeId === 1) {
            let saveAddTier = {
                tierName: tierName,
                discounts: [],
                subId: user.sub
            };

            axios.post('api/PriceList/SavePriceListTier', saveAddTier, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.isError) {
                    var errors = res.data.messages as any[];
                    for (var i = 0; i < errors.length; i++) {
                        toast.error(errors[i].content);
                    };
                } else {
                    plTiers.push(res.data);
                    toast.success("Price List Tier Saved Successfully");

                    let pricelist: PriceListItem[] = [];
                    let pricelistItem = addBlankRow(res.data.id, 1);
                    pricelist.push(pricelistItem);

                    let pricelistRate: PriceListItem[] = [];
                    let pricelistRateItem = addBlankRow(res.data.id, 1);
                    pricelistRate.push(pricelistRateItem);

                    setPriceListTier({ priceListTierId: res.data.id, priceListTierType: 1, priceListUniqueId: res.data.uniqueId });
                    setPriceListItems(pricelist);
                    setPricelistTiers(plTiers);
                    setTierName("");
                    setTierCustomerId(-1);
                    setUseOverhireRate(true);
                    setShowAddTier(false);
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
        } else {
            var customerId = tierCustomerId * 1;
            var customer = customerOptions.find(c => c.id === customerId);
            let saveAddTier = {
                customerid: customerId,
                customerName: customer?.name,
                isEws: false,
                discounts: [],
                subId: user.sub
            };

            axios.post('api/PriceList/SavePricelistCustom', saveAddTier, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.isError) {
                    var errors = res.data.messages as any[];
                    for (var i = 0; i < errors.length; i++) {
                        toast.error(errors[i].content);
                    };
                } else {
                    plTiers.push(res.data);
                    toast.success("Price List Custom Saved Successfully");

                    let pricelist: PriceListItem[] = [];
                    let pricelistItem = addBlankRow(res.data.id, 2);
                    pricelist.push(pricelistItem);

                    let pricelistRate: PriceListItem[] = [];
                    let pricelistRateItem = addBlankRow(res.data.id, 2);
                    pricelistRate.push(pricelistRateItem);

                    setPriceListTier({ priceListTierId: res.data.id, priceListTierType: 2, priceListUniqueId: res.data.uniqueId });
                    setPriceListItems(pricelist);
                    setPricelistTiers(plTiers);
                    setTierName("");
                    setTierCustomerId(-1);
                    setUseOverhireRate(true);
                    setShowAddTier(false);
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
        }
    }

    //END ADD TIER

    const updatePricelist = (pricelist: PriceListItem[]) => {
        setPriceListItems(pricelist);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (priceListItems.length === 1) {
            errorList["pricelistitems"] = "Please enter at least one item!";
            setErrors(errorList);
            return true;
        }

        var rowNumber = 0;
        var errorString = "Please enter the following values: ";
        var error = false;

        for (var i = 0; i < priceListItems.length - 1; i++) {
            rowNumber += 1;
            var newErrorString = "";

            if (priceListItems[i].itemId < 1) {
                newErrorString += "Item, ";
                error = true;
            }

            if (!priceListItems[i].basePrice || priceListItems[i].basePrice <= 0) {
                newErrorString += "Price, ";
                error = true;
            }

            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }

        }
        if (error) {
            formIsValid = false;
            errorList["pricelistitems"] = errorString;
        }
        setErrors(errorList);
        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            var changed = priceListItems.filter(p => p.isDirty);

            if (changed.length === 0) {
                toast.info("No items have changed.");
            } else {
                savePricelist(changed);
            }
        } else {
            toast.error("Please fix validation errors before Saving")
        }
    }

    const savePricelist = async (changed: PriceListItem[]) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var savePriceList = {
            priceListItems: changed,
            subId: user.sub
        };

        axios.post('api/PriceList/SavePricelist', savePriceList, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Price List Saved Successfully");
                setPricelistLoading(true);

                getPricelist(priceListTier.priceListTierId, priceListTier.priceListTierType);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const addNewTier = <AddPriceListTier showModal={showAddTier} tierName={tierName} customerId={tierCustomerId} tierDiscount={[]} customerOptions={customerOptions} systemCompanyId={3} hideModal={hideAddTier} updateTier={updateTierName} updateCustomer={updateCustomer} updateTierDiscount={updateTierDiscount} saveModal={saveAddTier} />

    const renderDetails = (
        <div>
            <div className="static-modal">
                {addNewTier}
            </div>
            <div className="input-group-parent">
                <label className="input-group" htmlFor="priceListTierId">
                    <span className="label">Tier/Customer</span>
                    <select className="select marginRight10" id="priceListTierId" name="priceListTierId" value={priceListTier.priceListUniqueId} onChange={(e) => handlePriceListChange(e)}>
                        <option hidden defaultValue=""></option>
                        {pricelistTiers.map(tier =>
                            <option key={tier.uniqueId} value={tier.uniqueId}>{tier.name}</option>
                        )};
                    </select>
                    <button className={readOnly ? "hidden" : "defaultbutton defaultbutton__small"} type="button" onClick={addTier}>Add New</button>
                </label>
            </div>
            <hr></hr>
            <div className="makeitbold makeitred">NOTE 1: Travel Amount is the total amount that will be charged for travel (not a one-way rate and not per item)</div>
            <div className="makeitbold makeitred">NOTE 2: Additional Hire Rate is not mandatory</div>
            <div className="makeitbold makeitred">NOTE 3: If event items go into overhire they will use original overhire price NOT this pricelist rate!</div>
            <div className={priceListTier.priceListTierId > 0 && !pricelistLoading ? "" : "hidden"}>
                {<Pricelist systemCompanyId={systemCompanyId} id={priceListTier.priceListTierId} priceListTierTypeId={priceListTier.priceListTierType} pricelist={priceListItems} itemList={itemList} customerOptions={[]} frequencyList={frequencyList} locationList={locationList} metresList={metresList} isEpa={false} isPumpClean={false} isFencing={false} isFencingCustom={false} isEvent={true} isPriceOnly={false} update={updatePricelist} />}
                {errors["pricelistitems"] ?
                    (errors["pricelistitems"]).split("\n").map((item: any, key: any) => {
                        return <span className="label errors" key={key}>{item}<br /></span>
                    })
                    : ""}
            </div>
            <div className={pricelistLoading ? "" : "hidden"}><p><em>Loading...</em></p></div>
            <div className="marginBottom10">
                <button className={readOnly ? "hidden" : "defaultbutton defaultbutton__large"} type="button" onClick={save} disabled={pricelistLoading || priceListTier.priceListTierId === 0 ? true : false}>Save</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <h1>Price List Events</h1>
            {contents}
        </div>
    );


}

export default AdminPriceListEventData;